export const getRefundableAmount = (payments = []) =>
  payments.reduce((val, item) => {
    if (!item.success) return val;
    return item.amount * 100 + val;
  }, 0) / 100;
